import React, { useEffect, useState, useRef } from 'react'
import api from '../components/api'
import { fmtMes } from '../components/generalFunctions'
import moment from 'moment'
import { Tab, Tabs } from 'react-bootstrap'
import { useQuery } from '@tanstack/react-query'
import DashboardTotalEmissaoModalidade from '../componentsPage/DashboardTotalEmissaoModalidade'
import DashboardTotalEmissoesPorMes from '../componentsPage/DashboardTotalEmissoesPorMes'
import ModalEmissaoVencer from '../modals/ModalEmissaoVencer'



interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    cnpj: string,


}

interface iDashboard {


totalClientes: number,
totalCorretores: number,
totalEmissoes: number,
totalProdutores: number,
totalTomadores: number,
valorTotalEmissoes: number,



}

const AnimatedNumber = React.memo(function AnimatedNumber({
    value,
    variant = 'number',
  }: {
    value: number
    variant?: 'number' | 'currency' | 'compact'
  }) {
    const [displayValue, setDisplayValue] = useState(value)
    const prevValueRef = useRef<number>(value)
  
    useEffect(() => {
      // 🔒 Se valor não mudou → não anima (ex: troca de TAB)
      if (prevValueRef.current === value) return
  
      const start = prevValueRef.current
      const end = value
  
      prevValueRef.current = value
  
      const duration = 600
      let startTime: number | null = null
  
      const animate = (timestamp: number) => {
        if (!startTime) startTime = timestamp
  
        const progress = Math.min((timestamp - startTime) / duration, 1)
        const easeOut = 1 - Math.pow(1 - progress, 3)
  
        const current = start + (end - start) * easeOut
        setDisplayValue(current)
  
        if (progress < 1) {
          requestAnimationFrame(animate)
        }
      }
  
      requestAnimationFrame(animate)
    }, [value])
  
    function format(v: number) {
      switch (variant) {
        case 'currency':
          return v.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
        case 'compact':
          return new Intl.NumberFormat('pt-BR', {
            notation: 'compact',
            compactDisplay: 'short',
            minimumFractionDigits: 1,
            maximumFractionDigits: 2,
          }).format(v)
        default:
          return Math.floor(v).toLocaleString('pt-BR')
      }
    }
  
    return <>{format(displayValue)}</>
  })


const Home = () => {

    var anoAtual: string = moment().format('YYYY')
    const dias: number = 60


    const [show, setShow] = useState<boolean>(false)


    //const [carregando, setCarregando] = useState<string>('block')

    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])
    const [ano, setAno] = useState<number | undefined>(Number(moment().year()))

    const [mes, setMes] = useState<number | undefined>();

    const [listaAnos, setListaAnos] = useState<number[]>([]);
    const [listaMeses, setListaMeses] = useState<number[]>([]);
    
    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')


    const [key, setKey] = useState<string | null>('totalEmissoesPorMes');


    const [usuario_id, setUsuario_id] = useState<number | undefined>()

    const [nome, setNome] = useState<string>('')

    useEffect(() => {

		if (dadosUsuarios) {

			var dados = JSON.parse(dadosUsuarios)

            //console.log(dados)
            
            setClientes(dados.clientes)
            setNome(dados.nome)
            setUsuario_id(dados.usuario_id)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : localStorage.getItem('cliente_id') ? Number(localStorage.getItem('cliente_id')) : undefined)
		    //setCliente_id(dados.cliente_id ? Number(dados.cliente_id) : undefined)
	

		}

	}, [dadosUsuarios])



    
    const { data } = useQuery({

        queryKey: ['dashboard', ano, mes, cliente_id],
        queryFn: async () => {

            try {


                var dataPost = {

                    ano: ano ? ano : null,
                    mes: mes? mes : null,
                    cliente_id: cliente_id ? cliente_id : null,
                    //usuario_id: usuario_id ? usuario_id : null,

                }

                const result = await api.post<iDashboard>('dashboard', dataPost)
                //console.log(result.data)
                return result.data ?? []


            } catch (err: any) {

                console.log(err.response)
                throw err

            }

        },
        enabled: !!ano && !!cliente_id


    })



    
    const { data: dataVencimento } = useQuery({

        queryKey: ['emissoesParaVencer', cliente_id],
        queryFn: async () => {

            try {


                var dataPost = {

                    dias,
                    cliente_id: cliente_id ? cliente_id : null,
                    //usuario_id: usuario_id ? usuario_id : null,

                }

                //console.log(dataPost, 'aqui vencer')

                const result = await api.post< { total: number }>('emissoesParaVencer', dataPost)
                //console.log(result.data)
                return result.data ?? {}


            } catch (err: any) {

                console.log(err.response)
                throw err

            }

        },
        enabled: !!cliente_id


    })



    function carregaAnos() {

        const x_array: number[] = [];
        
        for (let x = 2022; x <= parseInt(anoAtual); x++) {
            x_array.push(x);
        }
        
        setListaAnos(x_array.sort().reverse());
    }


    function carregaMeses() {

        const x_array: number[] = [];
        
        for (let x = 1; x <= 12; x++) {
            x_array.push(x);
        }
        
        setListaMeses(x_array);
    }

    useEffect(() => {

        carregaAnos()
        carregaMeses()
                
    }, [])


      const animationKey = `${ano}-${mes}-${cliente_id}`
      


    useEffect(() => {

        if (cliente_id) {

            localStorage.setItem('cliente_id', String(cliente_id))

        }

    }, [cliente_id])


    return (

        <div>

                    <div className="row g-3">
                        <div className="col-md-4">
                            
                            <select  className="form-control" style={{ backgroundColor: '#f4f2ff'}}  value={ano} onChange={event => setAno(event.target.value ? Number(event.target.value) : undefined)}>
                                
                                {listaAnos.map((rs) => 
                                
                                    <option key={rs} value={rs}>{rs}</option>
                            
                                )}

                            </select>
                        </div>
                        <div className="col-md-4">
                            
                            <select  className="form-control"  style={{ backgroundColor: '#f4f2ff'}}  value={mes} onChange={event => setMes(event.target.value ? Number(event.target.value) : undefined)}>
                                <option value="">[Mês]</option>
                                {listaMeses.map((rs) =>
                                
                                    <option key={rs} value={rs}>{fmtMes(rs)}</option>

                                )}

                            </select>
                        </div>
                        <div className="col-md-4">
                            
                            <select className="form-control" value={cliente_id} disabled={ clientes.length > 1 ? false : true } onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)}  
                            style={{ backgroundColor: '#f4f2ff'}}>
                            { clientes.length > 1 && ( <option value="">[Afiançadora]</option> )}
                            
                            {

                                clientes.map((rs: iClientes) => 
                                    
                                    <option value={rs.cliente_id}>{rs.cnpj} - {rs.nomeFantasia}</option>
                                )

                            }

                            </select>
                        </div>
                    </div>

                    <div className="row" style={{ marginTop: 15}}>

                        <div className="col-12 col-lg-4 col-xxl-3 d-flex">
                        <div className="card rounded-4 w-100 border-0 shadow-sm" style={{ background: '#F0F7FF' }}>
                            <div className="card-body">
                            <div className="mb-3">
                                <div className="wh-42 d-flex align-items-center justify-content-center rounded-circle"
                                    style={{ background: '#D6E9FF', color: '#0d6efd' }}>
                                <span className="material-icons-outlined fs-5">description</span>
                                </div>
                            </div>

                            <h4 className="mb-1">
                                <AnimatedNumber value={data?.totalEmissoes ?? 0} />
                            </h4>
                            <p className="mb-0 text-muted">Fianças emitidas</p>
                            </div>
                        </div>
                        </div>

                        {/* Montante */}
                        <div className="col-12 col-lg-4 col-xxl-3 d-flex">
                        <div className="card rounded-4 w-100 border-0 shadow-sm" style={{ background: '#F3FBF5' }}>
                            <div className="card-body">
                            <div className="mb-3">
                                <div className="wh-42 d-flex align-items-center justify-content-center rounded-circle"
                                    style={{ background: '#D9F5E3', color: '#198754' }}>
                                <span className="material-icons-outlined fs-5">payments</span>
                                </div>
                            </div>

                            <h4 className="mb-1">
                                <AnimatedNumber value={data?.valorTotalEmissoes ?? 0} variant="compact" />
                            </h4>
                            <p className="mb-0 text-muted">Montante</p>
                            </div>
                        </div>
                        </div>

                        <div className="col-12 col-lg-6 col-xxl-3 d-flex" style={{ cursor: 'pointer' }} onClick={() => setShow(true)} >
                        <div className="card rounded-4 w-100 border-0 shadow-sm" style={{ background: '#fff6f4' }}>
                            <div className="card-body">
                            <div className="mb-3">
                                <div className="wh-42 d-flex align-items-center justify-content-center rounded-circle"
                                    style={{ background: '#E0E5FF', color: '#4C6EF5' }}>
                                <span className="material-icons-outlined fs-5">groups</span>
                                </div>
                            </div>

                            <h4 className="mb-1">
                                <AnimatedNumber value={dataVencimento?.total ?? 0}/>
                            </h4>
                            <p className="mb-0 text-muted">Garantias a vencer em {dias} dias</p>
                            </div>
                        </div>
                        </div>

                        {/* Tomadores */}
                        <div className="col-12 col-lg-6 col-xxl-3 d-flex">
                        <div className="card rounded-4 w-100 border-0 shadow-sm" style={{ background: '#FFF8F1' }}>
                            <div className="card-body">
                            <div className="mb-3">
                                <div className="wh-42 d-flex align-items-center justify-content-center rounded-circle"
                                    style={{ background: '#FFE8CC', color: '#FD7E14' }}>
                                <span className="material-icons-outlined fs-5">account_balance</span>
                                </div>
                            </div>

                            <h4 className="mb-1">
                                <AnimatedNumber value={data?.totalTomadores ?? 0} />
                            </h4>
                            <p className="mb-0 text-muted">Tomadores</p>
                            </div>
                        </div>
                        </div>

                        </div>
                        



                    <Tabs
                    id="controlled-tab-example"
                    activeKey={key ?? "qtdeEmissoesModalidade"}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                    mountOnEnter={false}
                    unmountOnExit={false}
                    >
                        <Tab eventKey="totalEmissoesPorMes" title={<>Emissões por mês</>}>

                            <DashboardTotalEmissoesPorMes cliente_id={cliente_id} ano={ano} />

                        </Tab>
                        <Tab eventKey="qtdeEmissoesModalidade" title={
                            <>
                                Emissões por Modalidade
                            </>
                        }>

                            <DashboardTotalEmissaoModalidade cliente_id={cliente_id} mes={mes} ano={ano} />

                        </Tab>
                        
                    </Tabs>

                    
                    
                <ModalEmissaoVencer cliente_id={cliente_id} dias={dias} show={show} setShow={setShow} />


        </div>

    )

}


export default Home